import { ApiCreditPackIdentifier } from '#/api/types/ApiCreditPackIdentifier';

export const CREDIT_PACKS = [
  {
    id: ApiCreditPackIdentifier.JOB_PACK_3,
    quantity: 3,
    type: 'JOB',
  },
  {
    id: ApiCreditPackIdentifier.JOB_PACK_10,
    quantity: 10,
    type: 'JOB',
  },
  {
    id: ApiCreditPackIdentifier.JOB_PACK_20,
    quantity: 20,
    type: 'JOB',
  },
  {
    id: ApiCreditPackIdentifier.JOB_PACK_25,
    quantity: 25,
    type: 'JOB',
  },
  {
    id: ApiCreditPackIdentifier.JOB_PACK_30,
    quantity: 30,
    type: 'JOB',
  },
  {
    id: ApiCreditPackIdentifier.JOB_PACK_50,
    quantity: 50,
    type: 'JOB',
  },
  {
    id: ApiCreditPackIdentifier.JOB_PACK_100,
    quantity: 100,
    type: 'JOB',
  },
  {
    id: ApiCreditPackIdentifier.JOB_PACK_500,
    quantity: 500,
    type: 'JOB',
  },
  {
    id: ApiCreditPackIdentifier.INTERNSHIP_PACK_10,
    quantity: 10,
    type: 'INTERNSHIP',
  },
] satisfies {
  id: ApiCreditPackIdentifier;
  quantity: number;
  type: 'JOB' | 'INTERNSHIP';
}[];
